import { useMutation } from '@biletiniz/apollo';
import { TOKEN } from './gql/token';

export const useToken = apolloClient => {
  const [tokenMutation, { error, loading }] = useMutation(TOKEN, {
    client: apolloClient,
  });

  const getToken = refreshToken => {
    return tokenMutation({
      variables: { refreshToken },
      context: {
        headers: {
          authorization: null,
        },
      },
    });
  };

  return {
    error,
    getToken,
    loading,
  };
};
